import { fromArrayToString } from "../../../../../utils/v3/utils/from-array-to-string.js";
const normaliseQueryParams = (queryParams) => Object.entries(queryParams).filter((entry) => {
  const isValidValue = (value2) => ["string", "undefined"].includes(typeof value2);
  const [, value] = entry;
  return isValidValue(value) || Array.isArray(value) && value.every(isValidValue);
}).reduce((acc, [key, value]) => {
  const result = fromArrayToString(value);
  if (result !== void 0) {
    acc[key] = result;
  }
  return acc;
}, {});
export {
  normaliseQueryParams
};
//# sourceMappingURL=normalise-params.js.map
